export const FetchApiMixin = {
	methods: {
		fetchApiFailure(status, statusText) {
			console.log(statusText);
		}
		,fetchApiSuccess(message) {
			if(message){
				console.log(message);
			}
			else{
				console.log("HSLU: Fetch call success");
			}
		}
	}
}
